exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@keyframes spinner{10%{content:\"\\280B\"}20%{content:\"\\2819\"}30%{content:\"\\2839\"}40%{content:\"\\2838\"}50%{content:\"\\283C\"}60%{content:\"\\2834\"}70%{content:\"\\2826\"}80%{content:\"\\2827\"}90%{content:\"\\2807\"}to{content:\"\\280F\"}}.spinner[data-v-4104e12a]{color:var(--muted);font-family:var(--font-mono);font-size:24px}.spinner[data-v-4104e12a]:after{content:\"\\280B\";animation:spinner .5s linear infinite}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-4104e12a&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Spinner.vue
// module id = 8
// module chunks = 0